module.exports = __webpack_public_path__ + "img/7ff689d0-9baa-4d8f-a655-d683b72cc6f4.9b5202eb.png";